import {Table} from "antd";
import TextArea from "@common/TextArea";
import React, {useEffect, useState} from "react";
import Checkbox from "@common/Checkbox";

const StudentSkillResourceTable = (props) => {

    const {studentRecord, dataSource = [], handleSkillResourceChange, handleStudentCommentChange} = props;

    const [data, setData] = useState(dataSource),
        [columnData, setColumnData] = useState([]),
        [comment, setComment] = useState('');

    // console.log('dataSource: ',dataSource);
    const RESOURCE_TYPE = {
        VIDEO:'video',
        SECTION:'section',
        WALKTHROUGH:'walkthrough',
        EXERCISE:'exercise'
    }

    const checkedColMap = {
        [RESOURCE_TYPE.VIDEO]: false,
        [RESOURCE_TYPE.SECTION]: false,
        [RESOURCE_TYPE.WALKTHROUGH]: false,
        [RESOURCE_TYPE.EXERCISE]: false
    }

    const skillResourceColumns = {
        Skill:{title:'Mathematical skills', key:'skill', dataIndex:'skill', width:280,
            render:(val,skillRecord,idx)=>{return addCheckboxToRowSelect(val,skillRecord,idx)}
        },
        PercentCorrect:{title:'%', key:'percentCorrect', dataIndex:'percentCorrect',width:80, align:'center'},
        Section:{
            title: ()=>{return addCheckboxToTitle('Revisit this section from your textbook',RESOURCE_TYPE.SECTION)},
            key:RESOURCE_TYPE.SECTION, dataIndex:RESOURCE_TYPE.SECTION, align:'center',checked:false,
            render:(val,record,idx)=>{return skillResourceRender(val,record,RESOURCE_TYPE.SECTION)}
        },
        Video:{
            title: ()=>{return addCheckboxToTitle('Watch these worked example videos',RESOURCE_TYPE.VIDEO)},
            key:RESOURCE_TYPE.VIDEO, dataIndex:RESOURCE_TYPE.VIDEO, align:'center',checked:false,
            render:(val,record,idx)=>{return skillResourceRender(val,record,RESOURCE_TYPE.VIDEO)}
        },
        Walkthrough:{
            title: ()=>{return addCheckboxToTitle('See how you go with these',RESOURCE_TYPE.WALKTHROUGH)},
            key:RESOURCE_TYPE.WALKTHROUGH, dataIndex:RESOURCE_TYPE.WALKTHROUGH, align:'center', width:150,checked:false,
            render:(val,record,idx)=>{return skillResourceRender(val,record,RESOURCE_TYPE.WALKTHROUGH)}
        },
        Exercise:{
            title: ()=>{return addCheckboxToTitle('For more practice, do these exercise questions',RESOURCE_TYPE.EXERCISE)},
            key:RESOURCE_TYPE.EXERCISE, dataIndex:RESOURCE_TYPE.EXERCISE, align:'center',checked:false,
            render:(val,record,idx)=>{return skillResourceRender(val,record,RESOURCE_TYPE.EXERCISE)}
        }
    }

    // Handle checkbox change for individual cells
    const handleCellCheckboxChange = (checked, key, dataIndex) => {
        // console.log('handleCellCheckboxChange');
        const updatedData = data.map((record) => {
            if (record.key === key) {
                const updateRecord = {...record};
                updateRecord[dataIndex]["checked"] = checked;
                return updateRecord;
            }
            return record;
        });
        updateData(updatedData);
    };

    function updateData(data) {
        const updatedData = data.map((record) => {
            if (record.isConcept) {
                let checked = true;
                data.forEach((subRow) => {
                    if (checked && subRow.isSkill) {
                        if (subRow.conceptId === record.conceptId) {
                            checked = subRow[RESOURCE_TYPE.EXERCISE].checked && subRow[RESOURCE_TYPE.VIDEO].checked && subRow[RESOURCE_TYPE.SECTION].checked && subRow[RESOURCE_TYPE.WALKTHROUGH].checked
                        }
                    }
                });
                return Object.assign({}, record, {
                    checked: checked
                });
            }
            return record;
        });
        setData(updatedData);
    }

    useEffect(()=>{
        handleSkillResourceChange(data);
        const newArray = data.map(obj => {
            return {
                key: obj.key,
                checked: obj.checked
            };
        });
        // console.log('newArray: ',newArray);
    },[data]);

    useEffect(()=>{
        const skillResourceColumnsData = [];
        for(const [key,value] of Object.entries(skillResourceColumns)){
            skillResourceColumnsData.push(value);
        }
        setColumnData(skillResourceColumnsData);
    },[]);

    // Handle select all checkboxes in column
    const handleColumnCheckboxChange = (checked, columnType) => {
        checkedColMap[columnType] = checked;
        const updatedData = data.map((record) => {
            const updateRecord = {...record};
            if(!record.isConcept) {
                // console.log('updateRecord: ', updateRecord);
                // console.log('updateRecord[columnType]: ', updateRecord[columnType]);
                updateRecord[columnType]["checked"] = checked;
            }
            return updateRecord;
        });
        updateData(updatedData);
    };

    // Handle select all checkbox in row
    const handleRowCheckboxChange = (checked, handleRowRecord, idx) => {
        let updatedData;
        if(handleRowRecord.isConcept){
            let log = true;
            updatedData = data.map((row) => {
                const updateRecord = {...row};
                if (updateRecord.isSkill && updateRecord.conceptId === handleRowRecord.conceptId) {
                    if(updateRecord[RESOURCE_TYPE.SECTION].showCheckbox){
                        updateRecord[RESOURCE_TYPE.SECTION].checked = checked;
                    }
                    if(updateRecord[RESOURCE_TYPE.VIDEO].showCheckbox){
                        updateRecord[RESOURCE_TYPE.VIDEO].checked = checked;
                    }
                    if(updateRecord[RESOURCE_TYPE.WALKTHROUGH].showCheckbox){
                        updateRecord[RESOURCE_TYPE.WALKTHROUGH].checked = checked;
                    }
                    if(updateRecord[RESOURCE_TYPE.EXERCISE].showCheckbox){
                        updateRecord[RESOURCE_TYPE.EXERCISE].checked = checked;
                    }
                }
                if(log){
                    // console.log('after updateRecord: ',updateRecord);
                    log = false;
                }
                return updateRecord;
            });
        }else{
            updatedData = data.map((row) => {
                const updateRecord = {...row};
                if (updateRecord.key === handleRowRecord.key) {

                    if(handleRowRecord[RESOURCE_TYPE.SECTION].showCheckbox){
                        updateRecord[RESOURCE_TYPE.SECTION].checked = checked;
                    }
                    if(handleRowRecord[RESOURCE_TYPE.VIDEO].showCheckbox){
                        updateRecord[RESOURCE_TYPE.VIDEO].checked = checked;
                    }
                    if(handleRowRecord[RESOURCE_TYPE.WALKTHROUGH].showCheckbox){
                        updateRecord[RESOURCE_TYPE.WALKTHROUGH].checked = checked;
                    }
                    if(handleRowRecord[RESOURCE_TYPE.EXERCISE].showCheckbox){
                        updateRecord[RESOURCE_TYPE.EXERCISE].checked = checked;
                    }
                }
                return updateRecord;
            });
        }

        updateData(updatedData);
    };

    // Check if all checkboxes are selected in a column
    // const isColumnAllSelected = (updateData, dataIndex) => {
    //     return updateData.every((record) => record[dataIndex].checked);
    // };
    const isColumnAllSelected = (columnType) => {
        let result = true;
        data.forEach((record) => {
            // console.log('record: ',record);
            // console.log('record: ',record[columnType]);
            if(!record.isConcept && !record[columnType].checked){
                result = false;
            }
        });
        return result;
    };

    const isColumnSelected = (columnType) => {
        // if(checkedColMap[columnType]){
        //     console.log('columnType: ',columnType);
        // }
        return checkedColMap[columnType];
    };




    const skillResourceRender = (val,record,columnType)=>{
        // console.log('val: ',val);
        // console.log('record: ',record);
        const {checked = false, textLink = '', showCheckbox= false} = val;
        record.checked = checked;
        return (showCheckbox ?
            <Checkbox
                checked={isColumnSelected(columnType)||record[columnType].checked}
                 onChangeCallback={(e) =>
                     handleCellCheckboxChange(e.target.checked, record.key, columnType)
                 }
        style={{cursor:'pointer'}} label={textLink}
                // defaultChecked={checked}
                type="checkbox"/> : <>{textLink}</>);
    }

    const addCheckboxToTitle = (val,columnType)=> {
        return (<><Checkbox
            checked={isColumnAllSelected(columnType)}
            onChangeCallback={(e) =>
            handleColumnCheckboxChange(e.target.checked, columnType)
        } label={val} style={{cursor:'pointer'}}/></>)
    }

    const addCheckboxToRowSelect = (val,skillReco,idx)=> {
        // console.log('val: ',val);
        // console.log('record: ',record);
        const {checked = false, textLink = '', showCheckbox= false} = val;
        return (showCheckbox ?
            <Checkbox
                checked={val.checkboxType === 0 ? isAllSelected(val,skillReco,idx) : isWholeRowSelected(val,skillReco,idx)}
                onChangeCallback={(e) =>
                    handleRowCheckboxChange(e.target.checked,skillReco,idx)
                }
                style={{cursor:'pointer'}} label={textLink}
                // defaultChecked={checked}
                type="checkbox"/> : <>{textLink}</>);

    }

    const handleCommentChange = (e)=>{
        setComment(e.target.value);
    }

    useEffect((()=>{
        handleStudentCommentChange(comment, studentRecord.key);
    }),[comment])

    const isAllSelected = (val,skillRec0rd,idx)=>{
        // console.log('skillRec0rd: ',skillRec0rd);
        // console.log('val: ',val);
        let result = true;
        data.forEach((row) => {
            if (result && row.isSkill && row.conceptId === skillRec0rd.conceptId) {
                // console.log('row: ',row);
                result = (row[RESOURCE_TYPE.SECTION].checked || !row[RESOURCE_TYPE.SECTION].showCheckbox) &&
                    (row[RESOURCE_TYPE.VIDEO].checked || !row[RESOURCE_TYPE.VIDEO].showCheckbox) &&
                    (row[RESOURCE_TYPE.WALKTHROUGH].checked || !row[RESOURCE_TYPE.WALKTHROUGH].showCheckbox) &&
                    (row[RESOURCE_TYPE.EXERCISE].checked || !row[RESOURCE_TYPE.EXERCISE].showCheckbox);
            }

        });
        return result;
    }

    const isWholeRowSelected = (val,record,idx)=>{
        // console.log('isWholeRowSelected record: ',record);
        // console.log('val,record,idx: ',val,record,idx);
        return (
            (!record[RESOURCE_TYPE.SECTION].showCheckbox || record[RESOURCE_TYPE.SECTION].checked) &&
            (!record[RESOURCE_TYPE.VIDEO].showCheckbox || record[RESOURCE_TYPE.VIDEO].checked) &&
            (!record[RESOURCE_TYPE.WALKTHROUGH].showCheckbox || record[RESOURCE_TYPE.WALKTHROUGH].checked) &&
            (!record[RESOURCE_TYPE.EXERCISE].showCheckbox || record[RESOURCE_TYPE.EXERCISE].checked)
        );
        // }
    }


    return (<div className="flex" style={{flexDirection: "column", gap: "8px"}}>
        <Table className="ch-general-table-antd skill-resources-content"
               rowClassName={(record, index) => record.titleHighlight ? 'row-title-highlight' : ''}
               columns={columnData}
               pagination={false}
               scroll={{
                   y: 280
               }}
               dataSource={data}
        />
        <TextArea onChange={handleCommentChange} value={comment} style={{width: '50%'}} placeholder={"Write a comment for " + studentRecord.name} rows={2}/>
    </div>)

}
export default StudentSkillResourceTable;